import React from 'react';
import { Button } from './Button';

export interface EmptyStateProps {
  message: string;
  actionLabel?: string;
  onAction?: () => void;
}

/**
 * Shared empty-state block for source views. Callers decide the copy: a
 * "source is empty" message (usually with a Settings CTA) vs a "filter
 * matched nothing" message (usually with a reset-filter CTA) — see
 * `JiraView`/`GitHubView`/`SlackView`/`AgentsView` for the two branches.
 */
export const EmptyState: React.FC<EmptyStateProps> = ({ message, actionLabel, onAction }) => {
  return (
    <div
      data-testid="empty-state"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 10,
        padding: '32px 20px',
        textAlign: 'center',
        borderRadius: 14,
        background: 'var(--z-surface)',
        border: 'none',
        color: 'var(--z-dim)',
        fontSize: 13,
      }}
    >
      <span>{message}</span>
      {actionLabel && onAction ? (
        <Button variant="soft" size="sm" onClick={onAction}>
          {actionLabel}
        </Button>
      ) : null}
    </div>
  );
};
